import { useState, useEffect } from "react";
import { Search, X } from "lucide-react";
import { adminApi } from "../../api";

export default function PrecarioProdutoLookup({ currentId, currentLabel, onPick }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    let active = true;
    setBusy(true);
    const t = setTimeout(async () => {
      try {
        const r = await adminApi.precarioLookupProdutos(q);
        if (active) setItems(r.items || []);
      } catch { /* ignore */ }
      finally { if (active) setBusy(false); }
    }, 220);
    return () => { active = false; clearTimeout(t); };
  }, [q, open]);

  return (
    <div className="text-xs">
      <span className="text-[10px] uppercase text-[#978D78] font-bold block mb-0.5">Produto associado</span>
      <div className="flex items-stretch gap-1">
        <div className="flex-1 px-1.5 py-1 border border-[#E6E1D6] rounded bg-white">
          {currentId
            ? <span><span className="font-mono text-[10px] text-[#978D78]">#{currentId}</span> {currentLabel || ""}</span>
            : <span className="text-[#9CA3AF]">— sem produto —</span>
          }
        </div>
        <button type="button" onClick={() => setOpen(true)} className="px-2 py-1 text-[10px] uppercase tracking-wider bg-[#0F1829] text-white rounded hover:bg-black" data-testid="produto-lookup-btn">
          <Search size={11} className="inline" /> Procurar
        </button>
        {currentId && (
          <button type="button" onClick={() => onPick(null)} className="px-2 py-1 text-[10px] uppercase tracking-wider border border-[#E6E1D6] rounded hover:bg-[#FAF8F2]" data-testid="produto-lookup-clear">
            <X size={11} />
          </button>
        )}
      </div>

      {open && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-start justify-center p-4 overflow-auto" onClick={() => setOpen(false)}>
          <div className="bg-white rounded-md shadow-xl w-full max-w-2xl mt-12" onClick={(e) => e.stopPropagation()} data-testid="produto-lookup-modal">
            <div className="px-4 py-3 border-b border-[#F3F0E7] flex items-center justify-between">
              <h3 className="text-sm font-bold uppercase tracking-[0.12em]">Procurar produto B2B</h3>
              <button onClick={() => setOpen(false)} className="text-[#978D78]"><X size={14} /></button>
            </div>
            <div className="p-3">
              <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Pesquisar por descrição/referência..."
                className="w-full border border-[#E6E1D6] rounded px-2 py-1.5 text-sm" data-testid="produto-lookup-input" />
              <p className="text-[11px] text-[#6B7280] mt-1">Tipos B2B: CC, IH, SV.</p>
            </div>
            <div className="max-h-[55vh] overflow-y-auto">
              {busy && <p className="px-4 py-3 text-xs text-[#6B7280]">A procurar...</p>}
              {!busy && items.map((p) => (
                <button key={p.ID_Produto} onClick={() => { onPick(p); setOpen(false); }}
                  className="w-full text-left px-4 py-2 border-b border-[#F3F0E7] hover:bg-[#FAF8F2] text-xs" data-testid={`produto-lookup-pick-${p.ID_Produto}`}>
                  <div className="font-medium text-sm">{p.Descricao}</div>
                  <div className="text-[11px] text-[#6B7280]">
                    <span className="font-mono">#{p.ID_Produto}</span>
                    {p.Referencia && <span> · {p.Referencia}</span>}
                    <span> · {p.TipoProdutoDesc}</span>
                    {p.PrecoBaseClienteFinal != null && <span> · {Number(p.PrecoBaseClienteFinal).toLocaleString("pt-PT", { style: "currency", currency: "EUR" })}</span>}
                  </div>
                </button>
              ))}
              {!busy && !items.length && <p className="px-4 py-6 text-center text-xs text-[#6B7280]">Sem resultados.</p>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
